/*Js file imports*/
import $ from 'jquery';
import transformicons from './vendors/transformicons';
transformicons.add('.tcon');

import slick from './vendors/slick.js';
import easyAutocomplete from './vendors/jquery.easy-autocomplete.min.js';
import './utils.js';
import './dopplerDemo.js';
import './main.js';
import './search-webinars.js';
import './modal.js';
import './bootcamp.js';
import './bootcamp3.js';
import './dopplerTrainingSession.js';

import sharer from "sharer.js";

/*Sass file imports*/
import '../../css/src/style.scss';

function printClg() {

	const academy =
		`%c
			                      ...,..
...::...::.. ... ... ...,,................,. ... ... ... ... ....::...::..
...::...::..,.................................,. . . . . . . ....::...::..
...::...::.. .........,,,,,,,,,,,,,...............,. ... ... ....::...::..
...::...::..         .,,,,,,,,,,,,,,,,,,,,,,,...........      ...::...::..
...::...::.. ... ... ,,,,,,,.............................*.. ....::...::..
...::...::.. . . . ..,,,,****,,..........................*.......::...::..
...::...::.. ... ..**///*///*///**//*///**.......... ....*.. ....::...::..
...::...::..     .*********,         .*********,        ,,    ...::...::..
...::...::.. ... *//*///**.. ..,**.. ...*///*///*... ...*... ....::...::..
...::...::.. . ../*/*/*/*, . **/*/*/.. .*/*/*/*/*. . . .*. . ....::...::..
...::...::.. ....///*///*///*///*///*///*///*///*... ..,**.. ....::...::..
...::...::..    .********************************    .,,,*.   ...::...::..
...::...::.. ... .//*///*///*///*///*///*///*///.... ,,,,,,. ....::...::..
...::...::.. . . ../*/*/*/*/*/*/*/*/*/*/*/*/*/*. . ..,,,,,,. ....::...::..
...::...::.. ... ....///*///*///*///*///*///*... ... ... ... ....::...::..
...::...::..        .*********************.                   ...::...::..
 ... ...*//,.....****/**,... ... ... ... ... ... .
'########:::'#######::'########::'########::'##:::::::'########:'########::
 ##.... ##:'##.... ##: ##.... ##: ##.... ##: ##::::::: ##.....:: ##.... ##:
 ##:::: ##: ##:::: ##: ##:::: ##: ##:::: ##: ##::::::: ##::::::: ##:::: ##:
 ##:::: ##: ##:::: ##: ########:: ########:: ##::::::: ######::: ########::
 ##:::: ##: ##:::: ##: ##.....::: ##.....::: ##::::::: ##...:::: ##.. ##:::
 ##:::: ##: ##:::: ##: ##:::::::: ##:::::::: ##::::::: ##::::::: ##::. ##::
 ########::. #######:: ##:::::::: ##:::::::: ########: ########: ##:::. ##:
........::::.......:::..:::::::::..:::::::::........::........::..:::::..::
:::'###:::::'######:::::'###::::'########::'########:'##::::'##:'##:::'##:
::'## ##:::'##... ##:::'## ##::: ##.... ##: ##.....:: ###::'###:. ##:'##::
:'##:. ##:: ##:::..:::'##:. ##:: ##:::: ##: ##::::::: ####'####::. ####:::
'##:::. ##: ##:::::::'##:::. ##: ##:::: ##: ######::: ## ### ##:::. ##::::
 #########: ##::::::: #########: ##:::: ##: ##...:::: ##. #: ##:::: ##::::
 ##.... ##: ##::: ##: ##.... ##: ##:::: ##: ##::::::: ##:.:: ##:::: ##::::
 ##:::: ##:. ######:: ##:::: ##: ########:: ########: ##:::: ##:::: ##::::
..:::::..:::......:::..:::::..::........:::........::..:::::..:::::..:::::
			`

	console.log(academy, 'background: #222; color: #bada55')
}
printClg();
